import type { GateDefinition, GateContext } from './gates.types'
import { CONFIG_DDF_SMAVA_RCE_EDIT } from 'config/utils/config'
import { getRCEVoucherExperiment } from 'components/VoucherBanner/helpers/voucherExperiment'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import type { RCEVoucherActiveExperimentVariant } from 'components/VoucherBanner/VoucherBanner.types'
import {
  isCat4784SmavaExperiment,
  isCat4784SmavaDacSkipButtonVarB,
  isCat4784SmavaPremiumExcluded
} from './helpers/cat4784SmavaDacSkipButton'

const isRCEVoucherVariant = (
  context: GateContext,
  variant: RCEVoucherActiveExperimentVariant
) => {
  if (context.configName !== CONFIG_DDF_SMAVA_RCE_EDIT) return false

  const experiment = getRCEVoucherExperiment(context)
  if (!experiment) return false

  return context.experimentData[experiment] === variant
}

export const gates = {
  rceVoucherVariantB: {
    smava: (context) =>
      isRCEVoucherVariant(context, PossibleVariants.VARIATION_B)
  },
  rceVoucherVariantC: {
    smava: (context) =>
      isRCEVoucherVariant(context, PossibleVariants.VARIATION_C)
  },

  /** @cleanup CAT-4784 — DAC skip button V5 */
  cat4784SmavaStandardDacExperiment: {
    smava: isCat4784SmavaDacSkipButtonVarB
  },
  cat4784SmavaExperiment: {
    smava: isCat4784SmavaExperiment
  },
  cat4784SmavaPremiumExcludedExperiment: {
    smava: isCat4784SmavaPremiumExcluded
  }
} satisfies Record<string, GateDefinition>

export type GateName = keyof typeof gates
